<kendo-editor
   #editor
   fxFlexFill
   class="sam-form-row sam-no-margin"
   [ngClass]="!useTheme ? 'light-text-content' : 'themed-text-content'"
   [(ngModel)]="value"
   (ngModelChange)="textChanged($event)"
   [iframe]="false"
>
   >
   <kendo-toolbar *ngIf="smallView">
      <kendo-toolbar-buttongroup>
         <kendo-toolbar-button kendoEditorBoldButton></kendo-toolbar-button>
         <kendo-toolbar-button kendoEditorItalicButton></kendo-toolbar-button>
         <kendo-toolbar-button kendoEditorUnderlineButton></kendo-toolbar-button>
         <kendo-toolbar-button kendoEditorStrikethroughButton></kendo-toolbar-button>
      </kendo-toolbar-buttongroup>

      <kendo-toolbar-dropdownlist kendoEditorFormat></kendo-toolbar-dropdownlist>
   </kendo-toolbar>

   <kendo-toolbar *ngIf="!smallView">
      <kendo-toolbar-buttongroup>
         <kendo-toolbar-button kendoEditorBoldButton></kendo-toolbar-button>
         <kendo-toolbar-button kendoEditorItalicButton></kendo-toolbar-button>
         <kendo-toolbar-button kendoEditorUnderlineButton></kendo-toolbar-button>
         <kendo-toolbar-button kendoEditorStrikethroughButton></kendo-toolbar-button>
      </kendo-toolbar-buttongroup>

      <kendo-toolbar-dropdownlist kendoEditorFormat></kendo-toolbar-dropdownlist>

      <kendo-toolbar-buttongroup>
         <kendo-toolbar-button kendoEditorAlignLeftButton></kendo-toolbar-button>
         <kendo-toolbar-button kendoEditorAlignCenterButton></kendo-toolbar-button>
         <kendo-toolbar-button kendoEditorAlignRightButton></kendo-toolbar-button>
         <kendo-toolbar-button kendoEditorAlignJustifyButton></kendo-toolbar-button>
      </kendo-toolbar-buttongroup>

      <kendo-toolbar-buttongroup>
         <kendo-toolbar-button kendoEditorInsertUnorderedListButton></kendo-toolbar-button>
         <kendo-toolbar-button kendoEditorInsertOrderedListButton></kendo-toolbar-button>
         <kendo-toolbar-button kendoEditorIndentButton></kendo-toolbar-button>
         <kendo-toolbar-button kendoEditorOutdentButton></kendo-toolbar-button>
      </kendo-toolbar-buttongroup>

      <kendo-toolbar-buttongroup>
         <kendo-toolbar-button kendoEditorCreateLinkButton></kendo-toolbar-button>
         <kendo-toolbar-button kendoEditorUnlinkButton></kendo-toolbar-button>
      </kendo-toolbar-buttongroup>
      <kendo-toolbar-button kendoEditorInsertImageButton></kendo-toolbar-button>

      <kendo-toolbar-button *ngIf="!expandToolbar" text="..." (click)="expand()"></kendo-toolbar-button>

      <kendo-toolbar-buttongroup *ngIf="expandToolbar">
         <kendo-toolbar-button kendoEditorSubscriptButton></kendo-toolbar-button>
         <kendo-toolbar-button kendoEditorSuperscriptButton></kendo-toolbar-button>
      </kendo-toolbar-buttongroup>

      <kendo-toolbar-dropdownlist *ngIf="expandToolbar" kendoEditorFontSize></kendo-toolbar-dropdownlist>
      <kendo-toolbar-dropdownlist *ngIf="expandToolbar" kendoEditorFontFamily></kendo-toolbar-dropdownlist>
      <kendo-toolbar-colorpicker *ngIf="expandToolbar" kendoEditorForeColor></kendo-toolbar-colorpicker>
      <kendo-toolbar-colorpicker *ngIf="expandToolbar" kendoEditorBackColor></kendo-toolbar-colorpicker>

      <kendo-toolbar-button *ngIf="expandToolbar" kendoEditorInsertFileButton></kendo-toolbar-button>

      <kendo-toolbar-button *ngIf="expandToolbar" kendoEditorViewSourceButton></kendo-toolbar-button>
      <kendo-toolbar-button *ngIf="expandToolbar" kendoEditorCleanFormattingButton></kendo-toolbar-button>

      <kendo-toolbar-button
         *ngIf="expandToolbar"
         text=" {{ 'samwin.upload.upload_image' | translate }}"
         (click)="open()"
      ></kendo-toolbar-button>
   </kendo-toolbar>
</kendo-editor>

<samweb-upload-image-dialog #upload [editor]="editor"></samweb-upload-image-dialog>
